export const TERRA_ASSETS = 'https://assets.terra.money'
export const OBSERVER = 'wss://observer.terra.dev'
